var React = require('react');

function ChevronRight24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=24x24, Inverted=off"},React.createElement("path",{"id":"Vector","d":"M6.5 23l11-10.43v-1.14L6.5 1","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round"})));
}

ChevronRight24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronRight24x24;

ChevronRight24x24.default = ChevronRight24x24;
